import { PropsWithChildren } from "react";
import styles from "./bottomOverlayInfoContainer.module.scss";
import Button from "@Components/Button";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

type BottomOverlayContainerProps = PropsWithChildren & {
  onApplyClick: () => void;
  showButton?: boolean;
};

const BottomOverlayInfoContainer = ({
  children,
  onApplyClick,
  showButton = true,
}: BottomOverlayContainerProps) => {
  const { t } = useTranslationHook();
  return (
    <div className={styles.container}>
      <div className={styles.filterContainer}>{children}</div>
      {showButton && (
        <div className={styles.btnContainer}>
          <Button variant="success" onClick={onApplyClick}>
            {t("searchpage.howitworks.okaygotit")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(BottomOverlayInfoContainer, {
  componentName: "BottomOverlayInfoContainer-FilterSection-SearchPage",
  showForChina: true,
});
